import { render, staticRenderFns } from "./FileTranslateEntry.vue?vue&type=template&id=780b270c&scoped=true&"
import script from "./FileTranslateEntry.vue?vue&type=script&lang=js&"
export * from "./FileTranslateEntry.vue?vue&type=script&lang=js&"
import style0 from "./FileTranslateEntry.vue?vue&type=style&index=0&id=780b270c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b270c",
  null
  
)

export default component.exports